import React from 'react'
import { IonButton, IonIcon } from '@ionic/react'
import { chevronForward } from 'ionicons/icons'
import { useDispatch, useSelector } from 'react-redux'
import useAreAllErrorsCleared from '../hooks/useAreAllErrorsCleared.hook'
import useCheckToDisableBasedOnCustomStateRules from '../hooks/useCheckToDisableBasedOnCustomStateRules.hook'
import { getSignersSelector } from '../selectors'
import { lockChartButtonConfigurations } from '../utils/lockChartButtonConfigurations.utils'
import { getServiceIdSelector } from '../../user/selectors'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { getCrewListSelector } from '../../crew/selectors'
import { IServiceConfig } from '../../configurations/store/configurations.types'
import { useTranslation } from 'react-i18next'
import { useOfflineStatus } from '../../../utilities/isOnline.util'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { setLockChart } from '../store/completeChart.actions'
import { getAllPCRDocs } from '../../home/store/home.actions'
import { clearLocalNotifications } from '../../../utilities/localNotifications.util'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { saveRuleErrors } from '../../rules/store/rules.actions'

interface LockUploadBtnProps {
  isOnSignerPage?: boolean
}

const LockUploadBtn: React.FC<LockUploadBtnProps> = ({ isOnSignerPage = false }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const isOfflineStatus = useOfflineStatus()
  const serviceId = useSelector(getServiceIdSelector)
  const signerState = useSelector(getSignersSelector)
  const { signerList, complexRulesCount } = signerState
  const serviceConfig: IServiceConfig = useSelector(getServiceConfigSelector)
  const { PR_SIGNATURES, EXTRA_SECURITY_CREW } = serviceConfig
  const allErrorsCleared = useAreAllErrorsCleared()
  const crewList = useSelector(getCrewListSelector)

  const crewOptions = crewList.map((item) => item.userId)

  const disableBasedOnCustomStateRules = useCheckToDisableBasedOnCustomStateRules()
  const isButtonEnabled = lockChartButtonConfigurations(signerList, EXTRA_SECURITY_CREW, PR_SIGNATURES, crewOptions)

  const hasComplexRules = complexRulesCount?.filter((item) => item?.serviceId === Number(serviceId))

  const handleNext = () => {
    if (PR_SIGNATURES === 0 || isOnSignerPage) {
      dispatch(setLockChart(1, !isOfflineStatus))
      if (isOfflineStatus) {
        dispatch(saveRuleErrors())
        dispatch(getAllPCRDocs())
        clearLocalNotifications()
        history.push(AppRouterConstants.HOME_ROUTE)
      } else {
        history.push(TabConstants.SHARE_TAB)
      }
    } else {
      history.push(TabConstants.SIGNER_TAB)
    }
  }

  const showLockChartText = PR_SIGNATURES === 0 || isOnSignerPage

  return (
    <IonButton
      {...(isOnSignerPage ? { className: 'ion-padding-horizontal' } : { fill: 'solid' })}
      expand='full'
      color={'primary'}
      size='default'
      disabled={
        !isButtonEnabled ||
        !allErrorsCleared ||
        (hasComplexRules?.[0]?.ruleCount ?? 0) > 0 ||
        disableBasedOnCustomStateRules
      }
      onClick={handleNext}>
      {showLockChartText ? (
        !isOfflineStatus ? (
          t('completeChart.lockChartOnline')
        ) : (
          t('completeChart.lockChartOffline')
        )
      ) : (
        <>
          {t('completeChart.reviewLockChart')} <IonIcon slot='end' size='default' icon={chevronForward}></IonIcon>
        </>
      )}
    </IonButton>
  )
}

export default LockUploadBtn
